import { Component, Input, OnInit, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { TriggerTypes } from 'src/app/models/api/playbooks/triggers/triggerTypes.enum';
import { PlaybooksActionDefinitionInput } from 'src/app/models/componentInputs/playbookActionInput.interface';
import {
  AdaptersHttpService,
  AdapterResponse,
} from 'src/app/services/httpServices/adaptersHttpService/adapters-http.service';

export interface SendToSocActionDefinitionModel {
  adapterId?: string;
}

/**
 * Component for configuring the "Send to SOC" action in playbooks.
 * Allows users to select an adapter to route findings to.
 */
@Component({
  selector: 'app-send-to-soc-action',
  templateUrl: './send-to-soc-action.component.html',
  styleUrls: ['./send-to-soc-action.component.scss'],
})
export class SendToSocActionComponent implements OnInit {
  @Input() public fg: UntypedFormGroup;
  @Input() public playbooksActionInput: PlaybooksActionDefinitionInput;
  @Input() public triggerType: TriggerTypes;

  public adapters$: Observable<AdapterResponse[]>;

  private readonly _adaptersHttpService = inject(AdaptersHttpService);
  private _actionDefinitionModel?: SendToSocActionDefinitionModel;

  ngOnInit(): void {
    let adapterId = '';
    if (this.playbooksActionInput.actionDefinitionProperties) {
      this._actionDefinitionModel = this.playbooksActionInput
        .actionDefinitionProperties as SendToSocActionDefinitionModel;
      adapterId = this._actionDefinitionModel.adapterId ?? '';
    }

    this.fg.addControl('adapterId', new UntypedFormControl(adapterId, [Validators.required]));

    // Load available adapters
    this.adapters$ = this._adaptersHttpService.getAllAdapters$();
  }
}
